import 'flag-icon-css/css/flag-icon.css';

import { ChallengeResult, closeChallengeDialog } from '../../../modules/challenge';
import { CircularProgress, Typography } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../../modules';
import React, { Component, Fragment } from 'react';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { queryAuthStatus, challenge as soapChallenge } from '../../../modules/api';

import Button from '@material-ui/core/Button';
import ChallengeRequestProps from './ChallengeRequestProps';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const styles = (theme: Theme) => createStyles({
  progress: {
    display: 'block',
    margin: `${theme.spacing(2)}px auto`,
  },
  dialogActions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  error: {
    color: theme.palette.error.main
  },
  contactList: {
    maxWidth: theme.spacing(50),
    margin: `0 auto`,
  },
  contact: {
    cursor: 'pointer',
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  },
  chevron: {
    marginLeft: theme.spacing(2),
  },
})

type State = {
  loading: boolean
  statusCode: string
  timeoutId: ReturnType<typeof setTimeout> | null
  error: string,
  nextCheck: number | null
};

class OobBioAuthChallengeRequest extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      loading: true,
      statusCode: "",
      error: "",
      timeoutId: null,
      nextCheck: null
    }
  }

  readonly QueryAuthStatusInterval = 5

  componentDidMount() {
    this.handleChallenge()
    this.setState({ loading: false })
  }

  handleChallenge = () => {
    let args = {
      credentialChallengeRequestList: {
        acspChallengeRequestData: {
          payload: {
            $attributes: {
              $xsiType: {
                type: "OOBBioAuthChallengeRequest",
                xmlns: "http://ws.oobbio.csd.rsa.com"
              }
            }
          }
        }
      },
      eventDataList: {
        eventData: {
          eventType: this.props.challenge.analyzeRequest.eventDataList.eventData.eventType
        },
      }
    }

    this.setState({
      loading: true,
    })
    this.props.soapChallenge(args).then((data: any) => {
      try {
        let callStatus = data.credentialChallengeList.acspChallengeResponseData.callStatus

        if (callStatus.statusCode !== "SUCCESS")
          throw new Error("Received response status code: " + callStatus.statusCode)

        this.setState({
          loading: false,
          statusCode: callStatus.statusCode,
        })
        this.scheduleCheck()

      } catch (error) {
        console.error(error)
        this.setState({ loading: false, error: "Error sending challenge request" })
      }
    }).catch((error: Error) => {
      console.error(error)
      this.setState({ loading: false, error: "Error sending challenge request" })
    })
  }

  handleQueryAuthStatus = () => {
    this.setState({
      error: "",
    })

    let args = {
      credentialAuthStatusRequest: {
        acspAuthStatusRequestData: {
          payload: {
            $attributes: {
              $xsiType: {
                type: "OOBBioAuthAuthStatusRequest",
                xmlns: "http://ws.oobbio.csd.rsa.com"
              }
            }
          }
        }
      },
    }
    this.props.queryAuthStatus(args)
      .then((data: any) => {
        let status = data.credentialAuthStatusResponse.acspAuthStatusResponseData.callStatus.statusCode

        if (status === "PENDING") {
          this.scheduleCheck()
          return
        }

        if (status === "SUCCESS") {
          this.props.challengeResponse(ChallengeResult.Success)
        }
        else {
          this.props.challengeResponse(ChallengeResult.Failure)
        }
      }).catch((error: Error) => {
        console.error(error)
        this.props.challengeResponse(ChallengeResult.Error)
      })
  }

  handleBack = () => {
    this.props.challengeResponse(ChallengeResult.Pending)
  }

  scheduleCheck = () => {
    if (this.state.timeoutId)
      clearTimeout(this.state.timeoutId)

    this.setState({
      timeoutId: setTimeout(this.handleQueryAuthStatus, this.QueryAuthStatusInterval * 1000),
      nextCheck: new Date().getTime() + this.QueryAuthStatusInterval * 1000
    })
  }

  render() {
    const { loading, error } = this.state
    const { classes } = this.props

    return (
      <Fragment>
        {loading && !error &&
          <CircularProgress className={classes.progress} />
        }

        {!loading &&
          <Fragment>
            <DialogContent>
              <Typography className={classes.error}>{error}</Typography>
              <DialogContentText>
                Please complete biometric authentication on your registered mobile device
              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button onClick={this.handleQueryAuthStatus} color="primary">
                Check Now
              </Button>
              <Button onClick={this.handleBack} color="primary">
                Back
              </Button>
            </DialogActions>
          </Fragment>
        }
      </Fragment>
    )
  }
}


const mapStateToProps = ({ auth, authmethods, challenge }: IStoreState) => ({
  auth,
  authmethods,
  challenge
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      soapChallenge,
      queryAuthStatus,
      closeChallengeDialog
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, ChallengeRequestProps {
  // refer to ChallengeRequestProps.ts
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OobBioAuthChallengeRequest));